<template>
  <div>
    <b-card no-body>
      <b-card no-body>
        <b-table
          id="rewards"
          ref="rewards"
          class="mb-0"
          selectable
          select-mode="single"
          selectedVariant="success"
          striped
          small
          thead-class="top-fixed-thead thead-light"
          table-class="text-small"
          responsive
          show-empty
          :empty-text="$t('message.common.emptyTable')"
          :busy="isBusy"
          :items="items"
          :fields="fields"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Загрузка</strong>
            </div>
          </template>

          <template #cell(date)="row">
            {{formatTableDate(row.item.date)}}
          </template>

          <template #cell(type_id)="row">
            {{getTypeName(row.item.type_id)}}
          </template>

          <template #cell(summa)="row">
            <span :class="getSignForType(row.item.type_id).class">
              {{ getSignForType(row.item.type_id).symbol + " " + row.item.summa }}
            </span>
          </template>

          <template #cell(period)="row">
            {{formatTableDate(row.item.start_date)}} - {{formatTableDate(row.item.end_date)}}
          </template>
        </b-table>
      </b-card>

      <pagination-footer
        :total-rows="totalRows"
        :per-page.sync="perPage"
        @page-click="onPagination"
      >
        <template #footer-buttons>
          <b-pagination
            pills
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            @page-click="onPagination"
          />
        </template>
      </pagination-footer>
    </b-card>
  </div>
</template>

<script>
import users from "../../network/users";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";

export default {
  name: "UserRewards",
  components: { PaginationFooter },
  mixins: [
    users,
    helpers, dateFormatter, pageSearchService
  ],
  data() {
    return {
      isBusy: false,
      items: [],
      fields: [
        {
          key: 'date',
          label: "Дата",
          sortable: true,
        },
        {
          key: 'type_id',
          label: "Тип",
          sortable: true,
        },
        {
          key: 'summa',
          label: "Сумма",
          sortable: true,
        },
        {
          key: 'executor_name',
          label: "Кому",
          sortable: true,
        },
        {
          key: 'period',
          label: "Период",
        },
      ],
    }
  },
  async created() {
    this.types = this.getTypes();
    const query = this.$route.query;

    if (query) {
      this.query = query.query;
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    await this.getItems();
  },
  methods: {
    getTypes() {
      return [
        { id: 1, name: "Аванс", sign: "positive" },
        { id: 2, name: "Зарплата", sign: "positive" },
        { id: 3, name: "Премия", sign: "positive" },
        { id: 4, name: "Штраф", sign: "negative" },
      ]
    },
    getSignForType(type_id) {
      const type = this.types.find(x => x.id === type_id);
      if (type.sign === "positive") {
        return  {
          symbol: "+",
          class: "text-success"
        }
      } else {
        return  {
          symbol: "-",
          class: "text-danger"
        }
      }
    },
    getTypeName(type_id) {
      const type = this.types.find(x => x.id === type_id);
      return type.name;
    },
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.query,
      };

      this.isBusy = true;
      const result = await this.getUserRewards(data);
      this.isBusy = false;

      if (!result || !result.data) {
        this.items = [];
        this.totalRows = 0;
        const mess = "Что-то пошло не так. Попробуйте обновить страницу и повторить действие.";
        this.showError(mess);
        return;
      }

      this.items = result.data.rewards;
      this.totalRows = result.data.total;
    },
  }
}
</script>

<style>
#rewards td {
  text-align: center;
}

#rewards th {
  text-align: center;
  vertical-align: middle;
}

.top-fixed-thead{
  background-color: lightgray;
}

#footer {
  position: sticky;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/UserRewards.vue